import { get, post } from "@/api/http";
const listByLibId = (reqdata) =>get(`/welcome/listByLibId?libid=${reqdata}`);

const add = (reqdata) =>post("/systemConfig/add", reqdata);
const configUpdate = (reqdata) =>post("/systemConfig/update", reqdata);
const findByQueryInfo = (reqdata) =>post("/systemConfig/query", reqdata);
const configdelete = (reqdata) =>get(`/systemConfig/delete?ids=${reqdata}`);
const  getLibTree= (reqdata) =>post("/library/getLibTree", reqdata);
export default {
  listByLibId,
  add,
  configUpdate,
  configdelete,
  findByQueryInfo,
  getLibTree
};
